import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Form, Upload, notification, Icon, Row, Col, Button, Input, Select, InputNumber, Collapse, Switch } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../i18n/adminI18n';
import MainContainer from '../../components/MainContainer';
import Format from '../../utils/format';
import ApiCaller from '../../utils/api-caller';

const { Option } = Select;
const { Panel } = Collapse;
const { TextArea } = Input;

@inject(
  'loginStore',
  'templateStore',
  'webSettingStore',
  'CmsLanguageStore',
  'CmsMenuStore')
@observer
class WebSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingHomeImage: false,
      uploadingLoginImage: false,
      uploadingLogoImage: false
    }
  }

  componentDidMount() {
    this.props.loginStore.authenticateAdmin().then(response => {
      if (!response) {
        this.props.history.push('/admin/login');
      }
    });
    
    this.props.templateStore.getActive();
    this.props.CmsLanguageStore.getActives().then(() => {
      this.props.CmsMenuStore.getActives().then(() => {
        this.props.webSettingStore.getData();
      });
    });
  }

  // UPLOAD Settings

  dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok')
    }, 0);
  }

  // Home Image

  beforeUploadHomeImage = (file) => {
    const { t } = this.props;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingHomeImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeHomeImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.webSettingStore.sethomeImageUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.webSettingStore.sethomeImageUrl(resp.imageUrl);
          this.setState({ uploadingHomeImage: false });
        });
      }
    }
  }

  // Login Image

  beforeUploadLoginImage = (file) => {
    const { t } = this.props;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingLoginImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeLoginImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.webSettingStore.setloginImageUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.webSettingStore.setloginImageUrl(resp.imageUrl);
          this.setState({ uploadingLoginImage: false });
        });
      }
    }
  }

  // Logo Image

  beforeUploadLogoImage = (file) => {
    const { t } = this.props;
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
    if (!isJpgOrPng) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('You can only upload JPG/PNG file!'),
        placement: 'bottomRight',
      });
    }

    const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
    if (!isLessThan10Mb) {
      notification.warning({
        message: t('Failed to upload image'),
        description: t('Image must smaller or equal to 1MB!'),
        placement: 'bottomRight',
      });
    }

    if (isJpgOrPng && isLessThan10Mb) {
      this.setState({ uploadingLogoImage: true });
    }

    return isJpgOrPng && isLessThan10Mb;
  }

  uploadChangeLogoImage = (info, title) => {
    if (info.file.status) {
      if (info.file.status === 'uploading') {
        this.props.webSettingStore.setlogoImageUrl('');
        return;
      }
      if (info.file.status === 'done') {
        const category = 'CmsImage'
        const titleName = Format.RemoveSpecialChars(title) || 'Default'

        return ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(resp => {
          this.props.webSettingStore.setlogoImageUrl(resp.imageUrl);
          this.setState({ uploadingLogoImage: false });
        });
      }
    }
  }

  save = () => {
    const { t } = this.props;
    this.props.webSettingStore.update().then(resp => {
      if (!resp.isError) {
        notification['success']({
          message: t('Success'),
          description: t('Web Setting is successfully updated.'),
          duration: 1
        });
      }
    });
  }

  render() {
    const { t } = this.props;
    const { activeTemplate } = this.props.templateStore;

    const {
      data,
      currencies,
      timezones
    } = this.props.webSettingStore;

    const { data: activeMenus } = this.props.CmsMenuStore;
    const { activeLanguages } = this.props.CmsLanguageStore;

    return (
      <MainContainer title={t('Web Setting')} menukey='web-setting'>
        <Grid container spacing={2}>
          {
            data
              ?
              <Grid item xs={12}>
                <Form.Item label={t('Styles')} className='stm-margin-bottom-0'>
                  {
                    data
                      ?
                      <>
                        <Row>
                          <Col span={24} className='stm-border-width-1 
                                                    stm-border-style-solid 
                                                    stm-border-color-white-two 
                                                    stm-border-radius-4 
                                                    stm-width-100-percent 
                                                    stm-background-white 
                                                    stm-color-32323F
                                                    stm-padding-16'>

                            <Collapse className='stm-margin-top-8'>

                              <Panel key={1} header={t('General')}>
                                <>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Tenant ID')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <InputNumber
                                          min={0}
                                          value={data.tenantId}
                                          onChange={(value) => this.props.webSettingStore.settenantId(value)}
                                          className='stm-width-64' />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Currency')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <Select
                                          value={data.currencyCountry}
                                          onChange={(value) => this.props.webSettingStore.setcurrencyCountry(value)}
                                          className='stm-width-266'>
                                          {
                                            currencies.map(currency => {
                                              return (<Option key={currency.label} value={currency.label}>{currency.label}</Option>)
                                            })
                                          }
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Timezone')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <Select
                                          value={data.timezone}
                                          onChange={(value) => this.props.webSettingStore.settimezone(value)}
                                          className='stm-width-266'>
                                          {
                                            timezones.map(timezone => {
                                              return (<Option key={timezone.value} value={timezone.value}>{timezone.label}</Option>)
                                            })
                                          }
                                        </Select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Location')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <Input
                                          value={data.location}
                                          onChange={(e) => this.props.webSettingStore.setlocation(e.target.value)}
                                          className='stm-width-150' />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Show Hotel Facility as')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <Switch
                                          checkedChildren={t('Swipe Left / Right')}
                                          unCheckedChildren={t('Swipe Left / Right')}
                                          checked={data.isHotelFacilityCarousel}
                                          className='stm-margin-right-8'
                                          onChange={() => this.props.webSettingStore.setisHotelFacilityCarousel(true)} />
                                        <Switch
                                          checkedChildren={t('Vertical')}
                                          unCheckedChildren={t('Vertical')}
                                          checked={!data.isHotelFacilityCarousel}
                                          onChange={() => this.props.webSettingStore.setisHotelFacilityCarousel(false)} />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='stm-display-flex stm-align-items-center stm-width-100-percent stm-margin-bottom-8'>
                                    <div className='stm-width-15-percent'>{t('Show Hotel Offer as')}</div>
                                    <div className=''>
                                      <div className='stm-display-flex stm-width-100-percent'>
                                        <Switch
                                          checkedChildren={t('Swipe Left / Right')}
                                          unCheckedChildren={t('Swipe Left / Right')}
                                          checked={data.isHotelOfferCarousel}
                                          className='stm-margin-right-8'
                                          onChange={() => this.props.webSettingStore.setisHotelOfferCarousel(true)} />
                                        <Switch
                                          checkedChildren={t('Vertical')}
                                          unCheckedChildren={t('Vertical')}
                                          checked={!data.isHotelOfferCarousel}
                                          onChange={() => this.props.webSettingStore.setisHotelOfferCarousel(false)} />
                                      </div>
                                    </div>
                                  </div>
                                </>

                              </Panel>

                              <Panel key={2} header={t('Image')}>

                                {/* Home Image */}
                                <>
                                  <div className='stm-font-size-18 stm-line-height-20 stm-font-weight-bold stm-margin-bottom-8 stm-margin-top-16'>{t('Home Image')}</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14 stm-margin-bottom-4'>{t('Note')}:</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14'>
                                    <ol className='stm-padding-inline-start-24'>
                                      <li>{t('Supports only JPG, PNG, and SVG File')}</li>
                                      <li>{t('Maximum File Size: 1MB')}</li>
                                      <li>{t('Recommendation: 375 x 432')}</li>
                                    </ol>
                                  </div>
                                  <>
                                    {
                                      data.homeImageUrl !== ''
                                        ?
                                        <div className='stm-margin-bottom-10'>
                                          <Button type='danger'
                                            className='stm-font-size-14 stm-line-height-20'
                                            onClick={() => this.props.webSettingStore.sethomeImageUrl('')}>{t('Delete Home Image')}</Button>
                                        </div>
                                        :
                                        null
                                    }
                                  </>
                                  <Upload
                                    listType='picture-card'
                                    className='avatar-uploader'
                                    showUploadList={false}
                                    customRequest={this.dummyRequest}
                                    beforeUpload={this.beforeUploadHomeImage}
                                    onChange={(info) => this.uploadChangeHomeImage(info, 'HomeBackground')}
                                  >
                                    {
                                      data.homeImageUrl !== ''
                                        ?
                                        <img src={data.homeImageUrl} alt='avatar' className='stm-height-400 stm-width-auto' />
                                        :
                                        <div>
                                          <Icon style={{ color: '#32323F' }} type={this.state.uploadingHomeImage ? 'loading' : 'plus'} />
                                          <div className='stm-font-size-16 stm-line-height-20 stm-color-32323F'>{t('Upload')}</div>
                                        </div>
                                    }
                                  </Upload>
                                </>

                                {/* Login Image */}
                                <>
                                  <div className='stm-font-size-18 stm-line-height-20 stm-font-weight-bold stm-margin-bottom-8 stm-margin-top-16'>{t('Login Image')}</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14 stm-margin-bottom-4'>{t('Note')}:</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14'>
                                    <ol className='stm-padding-inline-start-24'>
                                      <li>{t('Supports only JPG, PNG, and SVG File')}</li>
                                      <li>{t('Maximum File Size: 1MB')}</li>
                                      <li>{t('Recommendation: 375 x 812')}</li>
                                    </ol>
                                  </div>
                                  <>
                                    {
                                      data.loginImageUrl !== ''
                                        ?
                                        <div className='stm-margin-bottom-10'>
                                          <Button type='danger'
                                            className='stm-font-size-14 stm-line-height-20'
                                            onClick={() => this.props.webSettingStore.setloginImageUrl('')}>{t('Delete Login Image')}</Button>
                                        </div>
                                        :
                                        null
                                    }
                                  </>
                                  <Upload
                                    listType='picture-card'
                                    className='avatar-uploader'
                                    showUploadList={false}
                                    customRequest={this.dummyRequest}
                                    beforeUpload={this.beforeUploadLoginImage}
                                    onChange={(info) => this.uploadChangeLoginImage(info, 'LoginBackground')}
                                  >
                                    {
                                      data.loginImageUrl !== ''
                                        ?
                                        <img src={data.loginImageUrl} alt='avatar' className='stm-height-400 stm-width-auto' />
                                        :
                                        <div>
                                          <Icon style={{ color: '#32323F' }} type={this.state.uploadingLoginImage ? 'loading' : 'plus'} />
                                          <div className='stm-font-size-16 stm-line-height-20 stm-color-32323F'>{t('Upload')}</div>
                                        </div>
                                    }
                                  </Upload>
                                </>

                                {/* Logo Image */}
                                <>
                                  <div className='stm-font-size-18 stm-line-height-20 stm-font-weight-bold stm-margin-bottom-8 stm-margin-top-16'>{t('Logo Image')}</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14 stm-margin-bottom-4'>{t('Note')}:</div>
                                  <div className='stm-color-32323F stm-font-size-12 stm-line-height-14'>
                                    <ol className='stm-padding-inline-start-24'>
                                      <li>{t('Supports only JPG, PNG, and SVG File')}</li>
                                      <li>{t('Maximum File Size: 1MB')}</li>
                                      <li>{t('Recommendation: 100 x 100')}</li>
                                    </ol>
                                  </div>
                                  <>
                                    {
                                      data.logoImageUrl !== ''
                                        ?
                                        <div className='stm-margin-bottom-10'>
                                          <Button type='danger'
                                            className='stm-font-size-14 stm-line-height-20'
                                            onClick={() => this.props.webSettingStore.setlogoImageUrl('')}>{t('Delete Logo Image')}</Button>
                                        </div>
                                        :
                                        null
                                    }
                                  </>
                                  <Upload
                                    listType='picture-card'
                                    className='avatar-uploader'
                                    showUploadList={false}
                                    customRequest={this.dummyRequest}
                                    beforeUpload={this.beforeUploadLogoImage}
                                    onChange={(info) => this.uploadChangeLogoImage(info, 'LogoBackground')}
                                  >
                                    {
                                      data.logoImageUrl !== ''
                                        ?
                                        <img src={data.logoImageUrl} alt='avatar' className='stm-height-100 stm-width-auto' />
                                        :
                                        <div>
                                          <Icon style={{ color: '#32323F' }} type={this.state.uploadingLogoImage ? 'loading' : 'plus'} />
                                          <div className='stm-font-size-16 stm-line-height-20 stm-color-32323F'>{t('Upload')}</div>
                                        </div>
                                    }
                                  </Upload>
                                </>

                              </Panel>

                              <Panel key={3} header={t('Translation')}>

                                {/* Column Name */}
                                <div className='stm-display-flex stm-stm-width-100-percent stm-background-white-three stm-font-size-14 stm-line-height-18 stm-font-weight-bold stm-color-495057 stm-border-bottom-width-2 stm-border-bottom-color-white-two stm-border-bottom-style-solid'>
                                  <div className='stm-width-20-percent stm-padding-8'>{t('Label')}</div>
                                  <>
                                    {
                                      activeLanguages.map(lang => {
                                        return (
                                          <div className='stm-width-20-percent stm-padding-8'>{lang.name}</div>
                                        )
                                      })
                                    }
                                  </>
                                </div>

                                {/* General */}
                                <>
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-16 stm-line-height-20 stm-font-weight-bold stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>{t('General')}</div>
                                  </div>

                                  {/* About Hotel */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>About Hotel</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.aboutHotelText}
                                                onChange={(e) => this.props.webSettingStore.setaboutHotelText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Add to Cart */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Add to Cart</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.addToCartText}
                                                onChange={(e) => this.props.webSettingStore.setaddToCartText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Back to Menu */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Back to Menu</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.backToMenuText}
                                                onChange={(e) => this.props.webSettingStore.setbackToMenuText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Bill Detail */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Bill Detail</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.billDetailText}
                                                onChange={(e) => this.props.webSettingStore.setbillDetailText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Book */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Book</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.bookText}
                                                onChange={(e) => this.props.webSettingStore.setbookText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Book Now */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Book Now</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.bookNowText}
                                                onChange={(e) => this.props.webSettingStore.setbookNowText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Booking Date */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Booking Date</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.bookingDateText}
                                                onChange={(e) => this.props.webSettingStore.setbookingDateText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Booking Time */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Booking Time</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.bookingTimeText}
                                                onChange={(e) => this.props.webSettingStore.setbookingTimeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Cancel */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Cancel</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.cancelText}
                                                onChange={(e) => this.props.webSettingStore.setcancelText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Car Type */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Car Type</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.carTypeText}
                                                onChange={(e) => this.props.webSettingStore.setcarTypeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Chat */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Chat</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.chatText}
                                                onChange={(e) => this.props.webSettingStore.setchatText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Choice of Delivery */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Choice of Delivery</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.choiceOfDeliveryText}
                                                onChange={(e) => this.props.webSettingStore.setchoiceOfDeliveryText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Confirm */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Confirm</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.confirmText}
                                                onChange={(e) => this.props.webSettingStore.setconfirmText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Confirm Your Booking */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Confirm your booking</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.confirmYourBookingText}
                                                onChange={(e) => this.props.webSettingStore.setconfirmYourBookingText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Destination */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Destination</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.destinationText}
                                                onChange={(e) => this.props.webSettingStore.setdestinationText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Detail */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Detail</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.detailText}
                                                onChange={(e) => this.props.webSettingStore.setdetailText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* F&B Offer */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>F&B Offer</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.fnbOfferText}
                                                onChange={(e) => this.props.webSettingStore.setfnbOfferText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Go to Cart */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Go to Cart</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.goToCartText}
                                                onChange={(e) => this.props.webSettingStore.setgoToCartText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Go to Order */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Go to Order</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.goToOrderText}
                                                onChange={(e) => this.props.webSettingStore.setgoToOrderText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Home */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Home</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.homeText}
                                                onChange={(e) => this.props.webSettingStore.sethomeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Hotel Offer */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Hotel Offer</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.hotelEventText}
                                                onChange={(e) => this.props.webSettingStore.sethotelEventText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Hotel Facility */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Hotel Facility</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.hotelFacilityText}
                                                onChange={(e) => this.props.webSettingStore.sethotelFacilityText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Item */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Item</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.itemText}
                                                onChange={(e) => this.props.webSettingStore.setitemText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Loading Data */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Loading Data</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.loadingDataText}
                                                onChange={(e) => this.props.webSettingStore.setloadingDataText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Login */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Login</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.loginText}
                                                onChange={(e) => this.props.webSettingStore.setloginText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Logout */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Logout</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.logoutText}
                                                onChange={(e) => this.props.webSettingStore.setlogoutText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Next */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Next</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.nextText}
                                                onChange={(e) => this.props.webSettingStore.setnextText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* No Data Found */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>No Data Found</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.noDataFoundText}
                                                onChange={(e) => this.props.webSettingStore.setnoDataFoundText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* No. Of Person */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>No. Of Person</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.noOfPersonText}
                                                onChange={(e) => this.props.webSettingStore.setnoOfPersonText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Not Available */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Not Available</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.notAvailableText}
                                                onChange={(e) => this.props.webSettingStore.setnotAvailableText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* OK */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>OK</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.okText}
                                                onChange={(e) => this.props.webSettingStore.setokText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Order */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Order</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.orderText}
                                                onChange={(e) => this.props.webSettingStore.setorderText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Payment Type */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Payment Type</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.paymentTypeText}
                                                onChange={(e) => this.props.webSettingStore.setpaymentTypeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Please choose */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Please choose</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.pleaseChooseText}
                                                onChange={(e) => this.props.webSettingStore.setpleaseChooseText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Please select menu option */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Please select menu option</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.pleaseSelectMenuOptionText}
                                                onChange={(e) => this.props.webSettingStore.setpleaseSelectMenuOptionText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Please select your order */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Please select your order</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.pleaseSelectYourOrderText}
                                                onChange={(e) => this.props.webSettingStore.setpleaseSelectYourOrderText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Room */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Room</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.roomText}
                                                onChange={(e) => this.props.webSettingStore.setroomText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Search */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Search</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.searchText}
                                                onChange={(e) => this.props.webSettingStore.setsearchText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Send message */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Send message</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.sendMessageText}
                                                onChange={(e) => this.props.webSettingStore.setsendMessageText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Service */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Service</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.serviceText}
                                                onChange={(e) => this.props.webSettingStore.setserviceText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Shopping Offer */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Shopping Offer</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.shoppingOfferText}
                                                onChange={(e) => this.props.webSettingStore.setshoppingOfferText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Soon */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Soon</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.soonText}
                                                onChange={(e) => this.props.webSettingStore.setsoonText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* This service is not-available */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>This service is not-available</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <TextArea
                                                rows={2}
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.thisServiceIsUnavailableText}
                                                onChange={(e) => this.props.webSettingStore.setthisServiceIsUnavailableText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Welcome */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Welcome</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.welcomeText}
                                                onChange={(e) => this.props.webSettingStore.setwelcomeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                </>

                                {/* Placeholder */}
                                <>
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-16 stm-line-height-20 stm-font-weight-bold stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Placeholder</div>
                                  </div>

                                  {/* Last Name */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Last Name</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.placeholderLastnameText}
                                                onChange={(e) => this.props.webSettingStore.setplaceholderLastnameText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Room No. */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Room No.</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.placeholderRoomText}
                                                onChange={(e) => this.props.webSettingStore.setplaceholderRoomText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                </>


                                {/* Confirm Page */}
                                <>
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-16 stm-line-height-20 stm-font-weight-bold stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Confirm Page</div>
                                  </div>

                                  {/* Preferred Date */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Preferred Date</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredDateText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredDateText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Preferred Time */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Preferred Time</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredTimeText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredTimeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Preferred Time - Now */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Now</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredTimeNowText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredTimeNowText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Preferred Time - 15mins Later */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>15mins Later</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredTime15MinutesLaterText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredTime15MinutesLaterText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Preferred Time - 30mins Later */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>30mins Later</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredTime30MinutesLaterText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredTime30MinutesLaterText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Preferred Time - 1 hour Later */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>1 hour Later</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.preferredTime1HourLaterText}
                                                onChange={(e) => this.props.webSettingStore.setpreferredTime1HourLaterText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Remark */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Remark</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.remarkText}
                                                onChange={(e) => this.props.webSettingStore.setremarkText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Select Time */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Select Time</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.selectTimeText}
                                                onChange={(e) => this.props.webSettingStore.setselectTimeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Service Fee */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Service Fee</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.serviceFeeText}
                                                onChange={(e) => this.props.webSettingStore.setserviceFeeText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Sub Bill */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Sub Bill</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.subTotalText}
                                                onChange={(e) => this.props.webSettingStore.setsubTotalText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Total Bill */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Total Bill</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.totalBillText}
                                                onChange={(e) => this.props.webSettingStore.settotalBillText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* VAT */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>VAT</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.vatText}
                                                onChange={(e) => this.props.webSettingStore.setvatText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                </>

                                {/* Order Page */}
                                <>
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-16 stm-line-height-20 stm-font-weight-bold stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Order Page</div>
                                  </div>

                                  {/* Request */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Request</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.requestText}
                                                onChange={(e) => this.props.webSettingStore.setrequestText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* In Progress */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>In Progress</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.inProgressText}
                                                onChange={(e) => this.props.webSettingStore.setinProgressText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Reserved */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Reserved</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.reservedText}
                                                onChange={(e) => this.props.webSettingStore.setreservedText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Schedule */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Schedule</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.scheduleText}
                                                onChange={(e) => this.props.webSettingStore.setscheduleText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* No Order Found */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>No Order Found</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <Input
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.noOrderFoundText}
                                                onChange={(e) => this.props.webSettingStore.setnoOrderFoundText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                </>

                                {/* Order Popup */}
                                <>
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-16 stm-line-height-20 stm-font-weight-bold stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Order Popup</div>
                                  </div>

                                  {/* Order Popup - Title */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Title</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <TextArea
                                                rows={2}
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.orderPopupTitleText}
                                                onChange={(e) => this.props.webSettingStore.setorderPopupTitleText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Order Popup - Success */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Success Message</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <TextArea
                                                rows={4}
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.orderPopupSuccessText}
                                                onChange={(e) => this.props.webSettingStore.setorderPopupSuccessText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Order Popup - Failed Message */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Failed Message</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <TextArea
                                                rows={4}
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.orderPopupFailedText}
                                                onChange={(e) => this.props.webSettingStore.setorderPopupFailedText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>

                                  {/* Order Popup - Loading Message */}
                                  <div
                                    className='stm-display-flex stm-stm-width-100-percent stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two stm-border-top-style-solid'
                                    style={{ background: '#FFFFFF', color: '#495057' }}>
                                    <div className='stm-width-20-percent stm-padding-8'>Loading Message</div>
                                    <>
                                      {
                                        activeLanguages.map(lang => {
                                          return (
                                            <div className='stm-width-20-percent stm-padding-8'>
                                              <TextArea
                                                rows={2}
                                                value={data.webSettingLanguages.find(fi => fi.languageId === lang.id)?.processingOrderLoadingText}
                                                onChange={(e) => this.props.webSettingStore.setprocessingOrderLoadingText(lang.id, e.target.value)}
                                                className='' />
                                            </div>
                                          )
                                        })
                                      }
                                    </>
                                  </div>
                                </>

                              </Panel>

                            </Collapse>
                          </Col>
                        </Row>
                      </>
                      :
                      null
                  }
                </Form.Item>

                <>
                  {
                    activeTemplate
                      ?
                      <>
                        <Form.Item label={t('Preview')}>
                          {
                            data
                              ?
                              <>
                                <Row>
                                  {/* Preview Login Page */}
                                  <Col span={8} className='stm-min-height-200 stm-padding-16 stm-align-items-center stm-justify-content-center'>
                                    <Row>
                                      <Col
                                        className='stm-width-375 stm-height-812 stm-padding-4 stm-color-white-two stm-padding-top-100 stm-background-size-cover'
                                        style={{
                                          background: data.loginImageUrl ? `url(${data.loginImageUrl})` : 'black'
                                        }}>
                                        <Row>
                                          <Col
                                            span={13}
                                            className='stm-text-align-right stm-padding-4 stm-color-white-two'
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                              color: activeTemplate.templateSetting.text.color,
                                              fontSize: activeTemplate.templateSetting.text.fontSize,
                                              height: activeTemplate.templateSetting.text.fontSize + 24
                                            }}>
                                            English
                                          </Col>
                                          <Col
                                            span={11}
                                            className='stm-text-align-left stm-padding-4'>
                                            <img src={require('../../assets/image/Icon/Dropdown.svg')} alt='dropdown' />
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={1} />
                                          <Col span={22} className='stm-border-stm-width-1 
                                                        stm-border-style-solid 
                                                        stm-border-radius-6 
                                                        stm-background-white 
                                                        stm-margin-top-10 
                                                        stm-padding-bottom-24'>
                                            <Row>
                                              <Col span={1} />
                                              <Col span={22} className='stm-text-align-center stm-margin-top-20 stm-margin-bottom-20'>
                                                {
                                                  data.logoImageUrl
                                                    ?
                                                    <img className='stm-max-width-160 stm-height-auto' src={data.logoImageUrl} alt='StayPlease' />
                                                    :
                                                    null
                                                }
                                              </Col>
                                              <Col span={1} />
                                            </Row>

                                            <Row>
                                              <Col span={1} />
                                              <Col span={22} className='stm-margin-bottom-10'>
                                                <Input
                                                  placeholder={data.webSettingLanguages.find(fi => fi.languageId === 1)?.placeholderRoomText}
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                    color: activeTemplate.templateSetting.text.color,
                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                    height: activeTemplate.templateSetting.text.fontSize + 24
                                                  }} />
                                              </Col>
                                              <Col span={1} />
                                            </Row>

                                            <Row>
                                              <Col span={1} />
                                              <Col span={22} className='stm-margin-bottom-10'>
                                                <Input placeholder={data.webSettingLanguages.find(fi => fi.languageId === 1)?.placeholderLastnameText}
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                    color: activeTemplate.templateSetting.text.color,
                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                    height: activeTemplate.templateSetting.text.fontSize + 24
                                                  }} />
                                              </Col>
                                              <Col span={1} />
                                            </Row>

                                            <Row>
                                              <Col span={1} />
                                              <Col span={22} className='stm-margin-top-10'>
                                                <Button className='stm-width-100-percent'
                                                  style={{
                                                    background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                    color: activeTemplate.templateSetting.buttonFooter.color,
                                                    fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                    fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                    height: activeTemplate.templateSetting.buttonFooter.fontSize + 32
                                                  }}>Login</Button>
                                              </Col>
                                              <Col span={1} />
                                            </Row>
                                          </Col>
                                          <Col span={1} />
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>

                                  {/* Preview Home Page */}
                                  <Col span={8} className='stm-min-height-200 stm-padding-16 stm-align-items-center stm-justify-content-center'>
                                    <Row>
                                      <Col className='stm-width-375 stm-height-432'>
                                        <Row>
                                          <Col
                                            span={24}
                                            className='stm-background-size-cover'
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                              background: activeTemplate.templateSetting.header.backgroundColor,
                                              color: activeTemplate.templateSetting.header.color,
                                              fontSize: activeTemplate.templateSetting.header.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                            }}>
                                            <Row>
                                              <Col span={4}
                                                className='stm-align-items-center stm-justify-content-center stm-display-flex stm-height-50'>
                                                <img src={require('../../assets/image/Icon/Menu.svg')} alt='Menu' />
                                              </Col>
                                              <Col span={16}
                                                className='stm-align-items-center stm-justify-content-center stm-display-flex stm-height-50 stm-font-weight-normal'
                                                style={{
                                                  fontSize: activeTemplate.templateSetting.header.fontSize,
                                                  lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                }}>
                                                <span>Welcome Guest</span>
                                              </Col>
                                              <Col span={4}
                                                className='stm-align-items-center stm-justify-content-center stm-display-flex stm-height-50'>
                                                <span className='padding-right-4'>EN</span>
                                                <img src={require('../../assets/image/Icon/Dropdown.svg')} alt='Menu' />
                                              </Col>
                                            </Row>
                                          </Col>
                                          <Col
                                            span={24}
                                            className='stm-width-375 stm-height-auto stm-padding-20 stm-background-size-cover'
                                            style={{
                                              background: data.homeImageUrl ? `url(${data.homeImageUrl})` : 'black'
                                            }}
                                          >
                                            <Row>
                                              <Col
                                                span={24}
                                                className='stm-margin-bottom-20 stm-margin-top-8'
                                              >
                                                <Row>
                                                  <Col
                                                    span={12}
                                                    className=''
                                                    style={{
                                                      fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                                      color: activeTemplate.templateSetting.homeHeader.color,
                                                      fontSize: activeTemplate.templateSetting.homeHeader.fontSize,
                                                      lineHeight: `${activeTemplate.templateSetting.homeHeader.fontSize + 2}px`
                                                    }}
                                                  >
                                                    <span>Room 1001</span>
                                                  </Col>
                                                  <Col
                                                    span={12}
                                                    className='stm-text-align-right'
                                                    style={{
                                                      fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                                      color: activeTemplate.templateSetting.homeHeader.color,
                                                      fontSize: activeTemplate.templateSetting.homeHeader.fontSize,
                                                      lineHeight: `${activeTemplate.templateSetting.homeHeader.fontSize + 2}px`
                                                    }}
                                                  >
                                                    <span>{data.location}</span>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col
                                                span={24}
                                                className='stm-font-size-14 stm-line-height-16 stm-margin-bottom-6'
                                              >
                                                <Row
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                                    color: activeTemplate.templateSetting.homeInfo.color,
                                                    fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.homeInfo.fontSize + 2}px`
                                                  }}
                                                >
                                                  <Col
                                                    span={12}
                                                    className=''
                                                  >
                                                    <span>C/In: 10/11 - 7:00 AM</span>
                                                  </Col>
                                                  <Col
                                                    span={12}
                                                    className='stm-text-align-right'
                                                  >
                                                    <span>Rain, 33.01°C</span>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col
                                                span={24}
                                                className='stm-font-size-14 stm-line-height-16'
                                              >
                                                <Row
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                                    color: activeTemplate.templateSetting.homeInfo.color,
                                                    fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.homeInfo.fontSize + 2}px`
                                                  }}
                                                >
                                                  <Col
                                                    span={12}
                                                    className=''
                                                  >
                                                    <span>C/Out: 11/11 - 7:00 AM</span>
                                                  </Col>
                                                  <Col
                                                    span={12}
                                                    className='stm-text-align-right'
                                                  >
                                                    <span>Sun, Nov 5, 2023</span>
                                                  </Col>
                                                </Row>
                                              </Col>
                                              <Col
                                                span={24}
                                                className=''
                                                style={{
                                                  marginTop: activeTemplate.templateSetting.menu.marginTop,
                                                  marginBottom: activeTemplate.templateSetting.menu.marginBottom
                                                }}
                                              >
                                                {/* Menu List */}
                                                <Row>
                                                  {
                                                    activeMenus.slice(0, (activeMenus.length - (activeMenus.length % activeTemplate.templateSetting.menu.column))).map(menu => {
                                                      return (
                                                        <Col key={menu.id} span={24 / activeTemplate.templateSetting.menu.column} className='stm-padding-2'>
                                                          <Row>
                                                            <Col
                                                              span={24}
                                                              className='stm-background-white-two stm-text-align-center stm-border-radius-4 stm-position-relative stm-padding-top-8 stm-padding-bottom-8'
                                                            >
                                                              {
                                                                menu.isSoon
                                                                  ?
                                                                  <div className='stm-menu-soon'>SOON</div>
                                                                  :
                                                                  null
                                                              }
                                                              <div
                                                                className=''
                                                              >
                                                                <img
                                                                  src={menu.imageUrl}
                                                                  alt='iconUrl'
                                                                  className='stm-height-40 stm-width-auto' />
                                                              </div>
                                                              <div
                                                                className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40 stm-padding-top-4'
                                                                style={{
                                                                  fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                                                  color: activeTemplate.templateSetting.menu.color,
                                                                  fontSize: activeTemplate.templateSetting.menu.fontSize,
                                                                  lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 2}px`
                                                                }}
                                                              >
                                                                <span>{menu.taskName}</span>
                                                              </div>
                                                            </Col>
                                                          </Row>
                                                        </Col>
                                                      )
                                                    })
                                                  }
                                                </Row>

                                                {/* Remaining Menu */}
                                                <>
                                                  {
                                                    activeMenus.length % activeTemplate.templateSetting.menu.column > 0
                                                      ?
                                                      <>
                                                        <Row>
                                                          {/* Blank */}
                                                          <>
                                                            {/* Menu Rows = 4 */}
                                                            <>
                                                              {
                                                                activeTemplate.templateSetting.menu.column === 4
                                                                  ?
                                                                  <>
                                                                    {
                                                                      activeMenus.length % activeTemplate.templateSetting.menu.column === 1
                                                                        ?
                                                                        <Col span={9} />
                                                                        :
                                                                        (
                                                                          activeMenus.length % activeTemplate.templateSetting.menu.column === 2
                                                                            ?
                                                                            <Col span={6} />
                                                                            :
                                                                            (
                                                                              activeMenus.length % activeTemplate.templateSetting.menu.column === 3
                                                                                ?
                                                                                <Col span={3} />
                                                                                :
                                                                                null
                                                                            )
                                                                        )
                                                                    }
                                                                  </>
                                                                  :
                                                                  null
                                                              }
                                                            </>

                                                            {/* Menu Rows = 3 */}
                                                            <>
                                                              {
                                                                activeTemplate.templateSetting.menu.column === 3
                                                                  ?
                                                                  <>
                                                                    {
                                                                      activeMenus.length % activeTemplate.templateSetting.menu.column === 1
                                                                        ?
                                                                        <Col span={8} />
                                                                        :
                                                                        (
                                                                          activeMenus.length % activeTemplate.templateSetting.menu.column === 2
                                                                            ?
                                                                            <Col span={4} />
                                                                            :
                                                                            null
                                                                        )
                                                                    }
                                                                  </>
                                                                  :
                                                                  null
                                                              }
                                                            </>

                                                            {/* Menu Rows = 2 */}
                                                            <>
                                                              {
                                                                activeTemplate.templateSetting.menu.column === 2
                                                                  ?
                                                                  <>
                                                                    <Col span={6} />
                                                                  </>
                                                                  :
                                                                  null
                                                              }
                                                            </>

                                                          </>

                                                          {/* Remaining Menu */}
                                                          <>
                                                            {
                                                              activeMenus.slice((activeMenus.length - (activeMenus.length % activeTemplate.templateSetting.menu.column)), activeMenus.length).map((menu) => {
                                                                return (
                                                                  <Col span={24 / activeTemplate.templateSetting.menu.column} className='stm-padding-2'>
                                                                    <Row>
                                                                      <Col
                                                                        key={menu.id}
                                                                        span={24}
                                                                        className='stm-background-white-two stm-text-align-center stm-border-radius-4 stm-position-relative stm-padding-top-8 stm-padding-bottom-8'
                                                                        onClick={() => this.menuClick(menu.taskID, menu.menuType, menu.isSoon)}
                                                                      >
                                                                        {
                                                                          menu.isSoon
                                                                            ?
                                                                            <div className='stm-menu-soon'>{data.soonText}</div>
                                                                            :
                                                                            null
                                                                        }
                                                                        <div className=''>
                                                                          <img src={menu.imageUrl} alt='iconUrl' className='stm-height-40 stm-width-auto' />
                                                                        </div>
                                                                        <div
                                                                          className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40 stm-padding-top-4'
                                                                          style={{
                                                                            fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                                                            color: activeTemplate.templateSetting.menu.color,
                                                                            fontSize: activeTemplate.templateSetting.menu.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 2}px`
                                                                          }}
                                                                        >
                                                                          <span>{menu.taskName}</span>
                                                                        </div>
                                                                      </Col>
                                                                    </Row>
                                                                  </Col>
                                                                )
                                                              })
                                                            }
                                                          </>
                                                        </Row>
                                                      </>
                                                      :
                                                      0
                                                  }
                                                </>

                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>

                                  {/* Preview HK Service */}
                                  <Col span={8} className='stm-min-height-200 stm-padding-16 stm-align-items-center stm-justify-content-center'>
                                    <Row>
                                      <Col className='stm-width-375 stm-height-432'>
                                        <Row>
                                          <Col
                                            span={24}
                                            className='stm-background-size-cover'
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                              background: activeTemplate.templateSetting.header.backgroundColor,
                                              color: activeTemplate.templateSetting.header.color,
                                              fontSize: activeTemplate.templateSetting.header.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                            }}>
                                            <Row>
                                              <Col span={4}
                                                className='stm-align-items-center stm-justify-content-center stm-display-flex stm-height-50'>
                                                <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                              </Col>
                                              <Col span={16}
                                                className='stm-align-items-center stm-justify-content-center stm-display-flex stm-height-50 stm-font-weight-normal'
                                                style={{
                                                  fontSize: activeTemplate.templateSetting.header.fontSize,
                                                  lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                }}>
                                                <span>HK Service</span>
                                              </Col>
                                              <Col span={4} />
                                            </Row>
                                          </Col>
                                          <Col span={24} className='stm-width-375 stm-height-auto'>
                                            <Row>
                                              <Col
                                                span={24}
                                                className='stm-margin-bottom-20 stm-margin-top-8'
                                              >
                                                <Row className='stm-height-160 stm-background-size-100-percent'>
                                                  <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160'>
                                                    <img src={'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground5331bd5e-a0c2-4b8b-9731-874b5b3c0b25.svg'} alt='Icon' />
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col span={24} className='stm-padding-16'>
                                                    <Row>
                                                      <Col
                                                        span={24}
                                                        className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                                        style={{
                                                          fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                          fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                          lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                          color: activeTemplate.templateSetting.buttonItemSelected.color,
                                                          border: `1px solid ${activeTemplate.templateSetting.buttonItemSelected.borderColor}`,
                                                          backgroundColor: activeTemplate.templateSetting.buttonItemSelected.backgroundColor
                                                        }}
                                                      >
                                                        Change Pillow
                                                      </Col>
                                                      <Col
                                                        span={24}
                                                        className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                                        style={{
                                                          fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                          fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                          lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                          color: activeTemplate.templateSetting.buttonItem.color,
                                                          border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                          backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                        }}
                                                      >
                                                        Change Towel
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                  <Col span={24} className='stm-margin-top-100 stm-padding-16'>
                                                    <Button
                                                      className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                                      style={{
                                                        background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                        fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                        fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                        lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                        color: activeTemplate.templateSetting.buttonFooter.color
                                                      }}
                                                    >
                                                      Order
                                                    </Button>
                                                  </Col>
                                                </Row>
                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </>
                              :
                              null
                          }
                        </Form.Item>
                      </>
                      :
                      null
                  }
                </>
                <Form.Item>
                  <Button type='primary' className='stm-font-size-18 line-height-20 stm-width-150 stm-height-48' onClick={this.save}>{t('Update')}</Button>
                </Form.Item>
              </Grid>
              :
              null
          }
        </Grid>
      </MainContainer>
    )
  }
}

export default withTranslation(undefined, { i18n: adminI18n })(WebSetting);